import { render, staticRenderFns } from "./SelectColorComponent.vue?vue&type=template&id=516e234a&"
import script from "./SelectColorComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectColorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports